/**
 * @file BtnShowPasswordModal
 */

'use strict';

/**
 * @classname BtnShowPasswordModal
 * @classdesc BtnShowPasswordModal
 */
export default class BtnShowPasswordModal {
	/**
	 * @constructor
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 */
	constructor($e, controller) {
		console.log(`BtnShowPasswordModal.constructor`);
		this._$e = $e;
		this._controller = controller;
		this._memberId = $e.attr('data-member-id');
		this._memberName = $e.attr('data-member-name');
		this._$modal = document.getElementById('modal-tmp-password');
		this._$e.on('click', () => this.onClick());
		this._$modal.addEventListener('hidden.bs.modal', () => this.closeModal());
		controller.on('onSetTmpPasswordComplete', () => this.changeBtnColor());
	}


	/**
	 * クリックのコールバック
	 *
	 * @memberof BtnShowPasswordModal
	 * @return {undefined}
	 */
	onClick() {
		console.log(`BtnShowPasswordModal.onClick`);
		$('#password_member_name').text(this._memberName);
		$('#tmp_issue_password_member_no').val(this._memberId);
		this._controller._memberId = this._memberId;
		$('#modal-tmp-password .validate').removeClass('ignore-validate');
	};


	/**
	 * モーダルクローズ
	 *
	 * @memberof BtnShowPasswordModal
	 * @return {undefined}
	 */
	closeModal() {
		console.log(`BtnShowPasswordModal.closeModal`);
		$('#modal-tmp-password .validate').val('').removeClass('is-invalid').addClass('ignore-validate');
		$('#modal-tmp-password .error-tip').removeClass('show');
		$('#modal-tmp-password .error-tip-inner').text('');
		$('#password_member_name').text('');
		$('#tmp_issue_password_member_no').val('');
		$('.anchor-show-password').removeClass('show').parent('.col-12').find('input').attr('type', 'password');
		this._controller._memberId = null;
	};


	/**
	 * ボタン色変更
	 *
	 * @memberof BtnShowPasswordModal
	 * @return {undefined}
	 */
	changeBtnColor() {
		if (this._memberId === this._controller._memberId) {
			console.log(`SetTmpPassword.changeBtnColor`);
			this._$e.removeClass('btn-primary').removeClass('btn-secondary').addClass('btn-info');
		}
	}
}
